<template>
    <a-tabs v-model:activeKey="activeKey">
        <a-tab-pane v-for="[key, item] in tabsMap" :key="key" :tab="item.label" />
    </a-tabs>
    <div class="con py-10px">
        <component ref="formRef" :is="tabsMap.get(activeKey)?.componet" />
    </div>
</template>

<script lang="tsx" setup>import { computed as _computed } from 'vue';

    import { ref, watch } from 'vue';
    import { useRoute } from 'vue-router';
    import PublciTable from './PublicTable.vue';
    import CustomTable from './CustomTable.vue';
    import { useI18n } from '@/locales/useI18n';

    const fy = _computed(() => useI18n().tm('mBooster.image'))
    const route = useRoute();
    const activeKey = ref('public');
    const tabsMap = new Map([
        [
            'public',
            {
                label: fy.value.public,
                key: 'public',
                componet: PublciTable,
            },
        ],
        [
            'custom',
            {
                label: fy.value.custom,
                key: 'custom',
                componet: CustomTable,
            },
        ],
    ]);
    watch(
        route,
        () => {
            if (route.query.type === 'custom') {
                activeKey.value = 'custom';
            } else {
                activeKey.value = 'public';
            }
        },
        {
            immediate: true,
        },
    );
    defineOptions({
        name: 'ComputeLabImage',
    });
</script>
<style lang="less" scoped>
    .image-create {
        &-header {
            display: flex;
            justify-content: space-between;
            margin-bottom: 20px;
        }
    }
</style>
